import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Access New Business Possibilities</h2>
            <p>
              The first impression is the last – your customer-facing platform
              is that first impression. With our best-in-class iPhone app
              development company, create appealing, efficient Apple software to
              find and dominate new business expansion gateways.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Brand Visibility and Recognition</h6>
                <p>
                  Reach a wider audience, increase visibility, and build loyalty
                  through high-quality, user-friendly iOS apps that Apple users
                  love to interact.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Engage More</h6>
                <p>
                  Leverage push notifications, in-app messaging, and
                  personalized content to boost customer interaction, loyalty,
                  and retention rates.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Sell Easily with CRO</h6>
                <p>
                  Optimize conversion funnels, reduce friction points, and
                  enhance user journeys to increase conversion rates, drive
                  sales, and maximize ROI.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improve KYC</h6>
                <p>
                  Access real-time analytics, user behavior insights, and
                  performance metrics to refine strategies for user-friendliness
                  and business growth.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Global Market Penetration</h6>
                <p>
                  Expand your global footprint with localization features,
                  multi-language support, and geo-targeted content delivery for
                  diverse audiences worldwide.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Extensible Solutions</h6>
                <p>
                  Modular architecture and cloud integration for seamless
                  scalability to ensure your iOS app grows together with
                  consistent performance.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
